import { Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col, Row, Tabs, Tag, Typography } from "antd";
import { Navbar } from "@components/Navigation/Navbar";
import { InjuryTable } from "@components/Settings/InjuryTable";
import { TreatmentLog } from "@components/Settings/TreatmentLog";
import { RtpPlanner } from "@components/Settings/RtpPlanner";
import "@styles/styles-HealthPage.css";

const TAB_DESCRIPTIONS: Record<string, string> = {
  "treatment-log": "Track the work that happens outside training. Record each treatment with its body area and timing, from pre-practice prep to post-game recovery and rehab.",
  injuries: "Log injuries and follow each recovery. While a player is injured, their data stays visible but does not skew your team and position averages.",
  "return-to-play": "Bring each injured player back with a phased plan. Set exit criteria for each phase, schedule the blocks, and track progress against each target.",
};

export const HealthPage = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const players = useSelector(({ team }: any) => team.players);
  const teamName = useSelector(({ team }: any) => team.info.display_name);

  if (!tab || !TAB_DESCRIPTIONS[tab]) return <Navigate to="/health/treatment-log" replace />;

  const isPlanOpen = Number(searchParams.get("plan")) > 0;

  const items = [
    { key: "treatment-log", label: "Treatment Log", content: <TreatmentLog /> },
    { key: "injuries", label: "Injuries", content: <InjuryTable players={players} team_name={teamName} /> },
    {
      key: "return-to-play",
      label: (
        <>
          Return to Play
          <Tag color="blue" bordered={false} className="health-tab-beta">
            Beta
          </Tag>
        </>
      ),
      content: <RtpPlanner />,
    },
  ].map(({ key, label, content }) => ({
    key,
    label,
    children: (
      <>
        {!(key === "return-to-play" && isPlanOpen) && (
          <Typography.Paragraph type="secondary" className="health-tab-description">
            {TAB_DESCRIPTIONS[key]}
          </Typography.Paragraph>
        )}
        {content}
      </>
    ),
  }));

  return (
    <>
      <Navbar />
      <Row justify="center" className="health-page">
        <Col span={20}>
          <Tabs
            type="card"
            centered
            activeKey={tab}
            onChange={(key) => navigate(`/health/${key}`)}
            items={items}
            destroyOnHidden
          />
        </Col>
      </Row>
    </>
  );
};
